import React, { useState } from "react";

import { useNavigate } from 'react-router-dom';


import '../css/common.css'

import imageOne from '../resource/donations/F26 (2).png'
import imageOtwo from '../resource/donations/F26.png'
import imageThree from '../resource/donations/F27.png'

import imageFive from '../resource/donations/L33.png'
import imageSix from '../resource/donations/L34.png'
import imageSeven from '../resource/donations/5.png'
import imageEight from '../resource/donations/L36.png'
import imageTen from '../resource/donations/L37.png'
import imageEleven from '../resource/donations/6.png'
import imageNine from '../resource/donations/F25.png'
import TitleChnage from "../Hook/TitleChnage";

const Donations = () => {

    TitleChnage("Donations")

    const navigate = useNavigate();

        const handleClick = (event) => {

            const pathMap = {
                annualsubscription:"/annualsubscription",
                buldingfounds:"/buldingfounds",
                healthfounds: "/healthfounds",
                lifelongmembership:"/lifelongmembership",
                maintenance:"/maintenance",
                sangafound : "/sangafound"
            }

            const path = event.currentTarget.id;
            const targetPath = pathMap[path]

            if (targetPath) {
                navigate(targetPath)
            }
        }

          const [isTextVisible, setIsTextVisible] = useState(false);
        
          const handleToggle = () => {
            setIsTextVisible((prev) => !prev);
          };
        

    return(
        <div className="page donation-page">
        <img src={imageOne} alt="" className="left-imge" />
        <img src={imageOtwo} alt="" className="right-imge" />



        <header>
            <div className="home-icon">
                {/* <img src="#" alt="Home Icon"> */}
            </div>
            <div className="title">
                <h1>Donations</h1>
                <img src={imageThree} width={200} />
            </div>
        </header>

        <section className="intro-text p-4">
            <p className="text-center text-bold">Willigness to give with joy and happiness - Meals, time, possession or skills 
                Willingness to give with no regret - What one really needs
            </p>

            <br />

            <p className="text-black">
                Form the time of Lord Buddha, monastic life has relied entirely on the 
                generosity of lay supporters. The four requisites essential to monastic life 
                food, shelter, clothing, and medicine -- are provided by lay 
                <span className="lowertext curser-pointer" onClick={handleToggle}>
            {isTextVisible ? "" : "more"}
          </span>
            </p>

            {isTextVisible && (
          <div className="hidden-text  text-black">
           
            <p className="mt-4">
                devotees, allowing 
                the Sangha to fully dedicate themselves to spiritual practice. 
            At Bhaddeka Vihari Monastery and Meditation Centre, we deeply value and sincerely appreciate any donations that support the Sangha and the ongoing maintenance of the Monastery. Your generosity plays a pivotal role in creating a conducive, secluded, and comfortable environment for the spiritual practices of both the monastics and the lay community.

            </p>

            <p className="mt-4">
            Every contribution, whether large or small, is an act of merit. Your offerings, whether in the form of food, other necessities, time, or energy, directly support these noble causes. It is through this shared spirit of giving that both donors and recipients benefit, strengthening the spiritual connection within the community.

              
            </p>

        

            <p className="mt-5">
            We are immensely grateful for your support, and we remind you that no act of kindness is ever too small. Your donation helps nurture the spiritual well-being of the Sangha, and in doing so, brings great merit to both you and the community.
            </p>

            <p className="mt-4">
            Thank you for your generous support.
            <span className="lowertext curser-pointer" onClick={handleToggle}>
                {isTextVisible ? "less" : ""}
              </span>
            </p>

        
          </div>
        )}
        </section>

        <section className="button-section-hermitage">
        <div className="left-col">
        <img src={imageFive} alt="" width={280} id="maintenance" onClick={handleClick}/>
            <img src={imageEight} alt="" width={280} id="buldingfounds" onClick={handleClick}/>
        </div>

        <div className="left-col">
        <img src={imageSix} alt="" width={280} id="healthfounds" onClick={handleClick}/>
            <img src={imageTen} alt="" width={280} id="sangafound" onClick={handleClick}/>
        </div>

        <div className="left-col">
        <img src={imageSeven} alt="" width={280} id="lifelongmembership" onClick={handleClick}/>
            <img src={imageEleven} alt="" width={280} id="annualsubscription" onClick={handleClick}/>
        </div>

        
    </section>

        <div className="box">
            <img src={imageNine} alt="" className="bottom-imge" />
        </div>
    </div>
    )
}


export default Donations